(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("moauth", [], factory);
	else if(typeof exports === 'object')
		exports["moauth"] = factory();
	else
		root["moauth"] = factory();
})(window, function() {
return 